const en = {
    accept: "Accept",
    changeLanguage: "Change language",
    footer: {
        mainPage: {
            mainPageText1: "PERSONALIZED SOLUTIONS. EXACTLY THE WAY YOU WANT.",
            askForOffer: "Ask for offer now!",
            aboutUs: "About us",
            solutions: "Solutions",
            socialMedia: "Social media",
            aboutInvitech: "About One",
            references: "References",
            career: "Career",
            socialResponsibility: "Social responsibility",
            centralizedProcurement: "Centralized procurement",
            smartVillage: "Smart village",
            forLargeCompanies: "For large companies",
            forSmallAndMediumCompanies: "For small and medium companies",
            forInstitutions: "For institutions",
            forWholesalers: "For wholesalers",
            businessServices: "Business services",
            infrastructureServices: "Infrastructure services",
            news: "News",
            press: "Press",
            blog: "Blog",
            loginToCustomerPortal: "Login to the customer portal",
            loginToTechnicalPortal: "Login to the technical portal"
        },
        dataProtection: "Data protection",
        dataProcessingCode: "Data processing code",
        termsAndConditions: "Terms and Conditions",
        gtc: "GTC",
        certificates: "Certificates",
        impress: "Impress",
        providerInformation: "Provider information",
        filteringSoftware: "Filtering Software",
        coServiceOffers: "Co-service offers",
        premiumServices: "Premium services",
        socialResponsibility: "Social responsibility (InnoMax)",
        iivrApplication: "IIVR Application"
    },
    urls: {
        aboutInvitech: "https://www.invitech.hu/invitechrol",
        references: "https://www.invitech.hu/ugyfeleink",
        socialResponsibility: "https://www.invitech.hu/innomax-fooldal",
        centralizedProcurement: "https://www.invitech.hu/kozpontositott-beszerzes",
        forLargeCompanies: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
        forSmallAndMediumCompanies: "https://www.invitech.hu/kis-es-kozepvallalkozasok-gyujto",
        forInstitutions: "https://www.invitech.hu/kozpontositott-beszerzes",
        businessServices: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
        infrastructureServices: "https://www.invitech.hu/infrastruktura",
        news: "https://www.invitech.hu/hirek",
        dataProcessingCode: "https://www.invitech.hu/storage/pbB0key1ENoZhpMpb0LVtlWc9sgyyEU6eIrQ98by.pdf",
        gtc: "https://www.invitech.hu/altalanos-szerzodesi-feltetelek-invitech",
        certificates: "https://www.invitech.hu/tanusitvanyaink",
        impress: "https://www.invitech.hu/impresszum",
        providerInformation: "https://www.invitech.hu/szolgaltato-adatai"
    },
    fields: {
        rating: "Please let us know briefly how we could improve the quality of our services: (optional)",
        ratingPlace: "Enter your message here",
        ratingCheck: "I consent to One contacting me by phone regarding my given answer"
    },
    cannotBeEmpty: "Cannot be empty",
    formatError: "Format error",
    mobileFormatError: "Format error (eg. +36...)",
    taxFormatError: "Format error (pl. 12345678-1-12)",
    title: "Welcome to One's customer satisfaction system!",
    desc: "Please confirm your ",
    desc2: "-point rating!",
    mandatory: "Mandatory",
    success: "Success",
    errorDuringRegistration: "Error during the registration process. Please try again!",
    send: "Send",
    dearCustomer: "Dear Customer!",
    sentMessage: "Thank you for honoring us all with your trust and for helping our work with your feedback.",
    sentMessageGood:"Thank you for honoring us all with your trust and for helping our work with your feedback. It is a great pleasure for us to welcome you among our satisfied customers!"
};

export default en;
